module.exports = __webpack_public_path__ + "static/media/google-pay.20f24c1b.svg";